export enum StageFilter {
  all = 'All',
  emergent = 'Emergent',
  early = 'Early',
  developing = 'Developing',
  consolidating = 'Consolidating',
  extending = 'Extending',
}

export enum CategoryFilter {
  general = 'General',
  australian = 'Australian',
  nsw = 'NSW',
  nz = 'NZ',
  victoria = 'Victoria',
}

export type FilterItem = {
  name: StageFilter | CategoryFilter;
  isDisabled: boolean;
};
